module.exports = __webpack_public_path__ + "media/images/official/plancheck_icon_60_1-80be6a7825b2c132362c8276468a1a56.svg";